const getStorefrontBaseUrl = () => (process.env.REACT_APP_STOREFRONT_URL || '').replace(/\/+$/, '')

export const slugify = (value = '') => String(value)
  .toLowerCase()
  .trim()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '')

const getCategoryName = (category) => slugify((category?.name || '').replace(/&/g, ' and '))

// Root categories link by their own slug; subcategories link via their top-level ancestor.
export const buildCategoryUrl = (category, rootCategory) => {
  const baseUrl = getStorefrontBaseUrl()

  if (!rootCategory || rootCategory.key === category.key) {
    const params = new URLSearchParams({ parent: getCategoryName(category), page: '1' })
    return `${baseUrl}/category?${params.toString()}`
  }

  const params = new URLSearchParams({
    parent: getCategoryName(rootCategory),
    id: category.key,
    name: getCategoryName(category)
  })
  return `${baseUrl}/category?${params.toString()}`
}

export const buildProductUrl = (keyCode, description = '') => {
  const params = new URLSearchParams({ id: keyCode, name: slugify(description) })
  return `${getStorefrontBaseUrl()}/product?${params.toString()}`
}

export const mapCategoriesToRoot = (categories = [], root = null, map = {}) => {
  categories.forEach((category) => {
    const resolvedRoot = root || category
    map[category.key] = resolvedRoot
    mapCategoriesToRoot(category.children || [], resolvedRoot, map)
  })
  return map
}

export const generateCategoryKey = () => `category-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`

export const countAllCategories = (categories = []) => {
  return categories.reduce((count, category) => {
    return count + 1 + countAllCategories(category.children || [])
  }, 0)
}

export const flattenCategoriesForSelect = (categories = [], level = 0, options = []) => {
  categories.forEach((category) => {
    options.push({
      value: category.key,
      label: `${'  '.repeat(level)}${category.name}`
    })

    if (category.children?.length) {
      flattenCategoriesForSelect(category.children, level + 1, options)
    }
  })

  return options
}

export const addCategoryNode = (categories = [], node, parentKey = null) => {
  if (!parentKey) {
    return [...categories, node]
  }

  return categories.map((category) => {
    if (category.key === parentKey) {
      return {
        ...category,
        children: [...(category.children || []), node]
      }
    }

    if (!category.children?.length) {
      return category
    }

    return {
      ...category,
      children: addCategoryNode(category.children, node, parentKey)
    }
  })
}

export const updateCategoryNode = (categories = [], targetKey, updater) => {
  return categories.map((category) => {
    if (category.key === targetKey) {
      return updater(category)
    }

    if (!category.children?.length) {
      return category
    }

    return {
      ...category,
      children: updateCategoryNode(category.children, targetKey, updater)
    }
  })
}

export const removeCategoryNode = (categories = [], targetKey) => {
  return categories
    .filter((category) => category.key !== targetKey)
    .map((category) => ({
      ...category,
      children: removeCategoryNode(category.children || [], targetKey)
    }))
}

export const findCategoryNode = (categories = [], targetKey) => {
  for (const category of categories) {
    if (category.key === targetKey) {
      return category
    }

    if (category.children?.length) {
      const found = findCategoryNode(category.children, targetKey)
      if (found) {
        return found
      }
    }
  }

  return null
}
